import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import classNames from "classnames";

import Title from "./Title";

type Props = {
  text: string;
  className?: string;
  onBackClick: () => void;
  isDisabled?: boolean;
};

const HeaderWithBack = ({
  text,
  className = "",
  onBackClick,
  isDisabled,
}: Props) => {
  return (
    <div className={classNames("flex items-center pb-22", className)}>
      <button
        onClick={onBackClick}
        className="mr-4"
        aria-label="Volver"
        disabled={isDisabled}
      >
        <ArrowBackIcon
          fontSize="large"
          className={
            isDisabled
              ? "cursor-not-allowed opacity-40"
              : "text-white hover:text-auth-blue"
          }
        />
      </button>

      <Title text={text} className="pb-0" />
    </div>
  );
};

export default HeaderWithBack;
